import { buildTimeDuration } from './buildTimeDuration';
import { padTimeInteger } from './padTimeInteger';

/**
 * A string representation of a duration for a user session. Assumes that
 * sessions may or may not be more than an hour. To prevent confusion all
 * times show hours, even those that are less than an hour.
 *
 * @param {number} numberOfMilliseconds - number of milliseconds
 * @returns {string} - a string representation of duration
 */
export const sessionDurationString = (numberOfMilliseconds: number): string => {
  const { hours, minutes, seconds } = buildTimeDuration(numberOfMilliseconds);

  return `${hours}:${padTimeInteger(minutes)}:${padTimeInteger(seconds)}`;
};
